import React from 'react';
import {getThreads, setToken} from '../actions/SupportAction';
import {connect} from 'react-redux';
import '../styles/css/support.forum.css';
import ForumContainer from '../components/Support.Forum';
// import ForumPost from '../components/Forum.Post';
import ForumThread from './Forum.Thread';
import {Route, Switch} from 'react-router-dom';
import ForumPost from '../components/editorTest';
import {pageView, trackEvent} from '../util/tracking'

// Running short on time from this point. Going shit mode from here

class Forum extends React.Component{
  constructor(){
    super();
    this.state={
      pageLength: null,       // total number of pages (for pagination)
      threads: null,            // list of threads in the current page
      page: 1,                // current page
      maxButtons: 5,  // number of buttons in pagination also have to change in supportAction.js
      query:{
        author: true,         // true :see only my posts, false :see all posts
        category: null,
        search: null
      }
    };
  }

  componentWillMount(){
    let {page} = this.state;
    let {forumList, tokenList, pageLength, getThreads} = this.props;

    if(!forumList){
      getThreads(tokenList[page-1]);
    }else{
      this.setState({
        pageLength: pageLength,
        threads: forumList[page-1],
      });
    }
    pageView();
    trackEvent("SETTING", "Community - See Forum", "")
  }

  componentWillReceiveProps(nextProps){
    // this is to update the threadlist when new thread is posted and update the list as new post is posted
    if(nextProps.updateForum){
      this.setState({page:1})
      this.props.getThreads(this.props.tokenList[0]);
      // getThreads(tokenList[page-1]);
    }else{

      let {page, maxButtons} = this.state;
      // let currentPg = Math.floor((page-1)/maxButtons);
      // processing got a little slow by doing this ?? why??
      let currentPg = (page-1)%maxButtons;
      let threads;
      if(nextProps.forumList.length===0){
        threads=[];
      }else {
        threads=nextProps.forumList[currentPg];
      }
      this.setState({
        pageLength : nextProps.pageLength,
        threads : threads
      });
    }
    if(this.props.pageLength !== nextProps.pageLength){
      this.setState({
        pageLength: nextProps.pageLength
      })
    }
  }

  shouldComponentUpdate(nextProps, nextState){
    if(this.props.location === nextProps.location && this.state === nextState){
      return false;
    }
    return true;
  }

// this pagination needs to be updated. Really not the best way
  handleSelect(eventKey) {
    let {maxButtons, page} = this.state;
    let clickedPg = Math.floor((eventKey-1)/maxButtons);
    let currentPg = Math.floor((page-1)/maxButtons);

    if( clickedPg !== currentPg || eventKey === 1){
      this.props.setToken(this.props.tokenList[clickedPg]);
      this.props.getThreads(this.props.tokenList[clickedPg]);
    }

    this.setState({
      page: eventKey,
      threads: this.props.forumList[eventKey-1]
    });
  }

  onClickHandler(id, evt){
    this.props.history.push('/forum/'+id);
  }

  // 기능 추가 구현 하기 (see my posts, see A category posts)
  onAuthorSelect(){
    this.setState({
      query: {
        ...this.state.query,
        author: !this.state.query.author
      }
    })
  }

  onSearchChange(evt){
    this.setState({
      query:{
        ...this.state.query,
        search: evt.target.value
      }
    })
  }

  onEnter(e){
    if(e.key==='Enter'){
      e.preventDefault();
      this.onSearchEnter();
    }
  }

  // using in above three enter
  onSearchEnter(){
    alert("input: "+this.state.query.search);
  }

  render(){
    let handlers = {
      handleSelect : this.handleSelect.bind(this),
      onClickHandler : this.onClickHandler.bind(this),
      onAuthorSelect : this.onAuthorSelect.bind(this),
      onSearchChange : this.onSearchChange.bind(this),
      onSearchEnter : this.onSearchEnter.bind(this),
      onEnter : this.onEnter.bind(this)
    };
    return(
      <Switch>
        <Route exact path="/forum" render={()=>
          <ForumContainer state={this.state} handlers={handlers}/>}/>
        <Route exact path="/forum/new-post" component={ForumPost}/>
        <Route exact path="/forum/:id" component={ForumThread}  />
      </Switch>
    );
  }
}


const mapDispatchToProps = dispatch =>{
  return{
    getThreads: (token) =>{
      dispatch(getThreads(token));
    },
    setToken: (token)=>{
      dispatch(setToken(token));
    }
  };
};

const mapStateToProps = (state, props) =>{
  return{
    forumList : state.support.forum,
    pageLength : state.support.pageLength,
    thread : state.support.thread,
    tokenList: state.support.tokenList,
    updateForum: state.support.updateForum
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Forum);



// WEBPACK FOOTER //
// ./src/containers/Forum.js